var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTcmMedicalRecordNum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1662542919061,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 67135,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M894.8 487.3H129.2c-19.3 0-35.1 15.7-35.1 34.9v8.1c0 17.3 12.8 31.7 29.5 34.4C141.8 701.8 232 816.4 355.3 869.9v26.2c0 17.7 14.6 32.2 32.4 32.2h248.7c17.8 0 32.4-14.5 32.4-32.2v-26.2C792 816.4 882.2 701.8 900.4 564.6c16.7-2.7 29.5-17.1 29.5-34.4v-8.1c0-19.1-15.8-34.8-35.1-34.8z m-578.9-51.9h317.3L246.4 117c-25.2-25-66.4-25-91.6 0L139 132.7c-25.2 25-25.2 65.9 0 91l176.9 211.7z",
    "p-id": 67136,
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcmMedicalRecordNum);
export default __webpack_public_path__ + "static/media/tcmMedicalRecordNum.21e5bab5.svg";
export { ForwardRef as ReactComponent };